import { lazy } from "react";

const UploadDocument = lazy(() => import("../../components/unprotected/UploadDocument"));
const SendLead = lazy(() => import("../../components/unprotected/SendLead"));
const UnsubscribeEmail = lazy(() => import("../../components/unprotected/UnsubscribeEmail"));
const SalesAgentTemplate = lazy(() => import("../../components/unprotected/SalesAgentTemplate"));
const DownLoadFile = lazy(() => import("../../components/unprotected/DownLoadFile"));
const ReferralTemplate = lazy(() => import("../../components/unprotected/ReferralTemplate"));
const SesSubscribe = lazy(() => import("../../components/unprotected/SesSubscribe"));

const AlwaysAccessibleRoutes = [
    { path: "/downloadfile/:fileNameToken/:fileName", element: <DownLoadFile /> },
    { path: "/referraltemplate/:token", element: <ReferralTemplate /> },
    { path: '/sesSubscribeSuccess', element: <SesSubscribe type={'SUCCESS'} /> }, //need to verify/make in use
    { path: '/sesSubscribeFailure', element: <SesSubscribe type={'FAILURE'} /> }, //need to verify/make in use
    { path: "/sales-agent-template/:token", element: <SalesAgentTemplate /> },
    { path: "/uploaddocument/:token", element: <UploadDocument /> }, //need to verify 
    { path: "/unsubscribeEmail/:leadId/:leadEmail", element: <UnsubscribeEmail /> },
    { path: "/sendleads/:clientId/:leadDatabaseIds/:leadReportId/:alertTypeId", id: "CUSTOMER_SEND_LEADS", element: <SendLead /> },
];

export default AlwaysAccessibleRoutes;
